<script lang="ts">
  import { PortableText } from "@portabletext/svelte";
  import { contentBlockComponents } from "./utils";
  import type { DetailsSummary } from "$lib/types/shared";
  import Summary from "$lib/Summary.svelte";

  interface Props {
    portableText: PortableText;
  }

  let { portableText }: Props = $props();
  const value: DetailsSummary = $derived(portableText.value);
</script>

<details class="border-solid border-2 border-$fg rounded-$s-2 my-4">
  <Summary link class="text-base">{value.summary}</Summary>
  <div class="mx-4">
    <PortableText
      value={value.details}
      components={contentBlockComponents}
      onMissingComponent={false}
    />
  </div>
</details>
